(function () {
    "use strict";

    angular
        .module("showcaseApp")
        .component("importListItem", {
            templateUrl:
                "app/admin/flyers/import/import-list-item/import-list-item.html",
            controller: ImportListItemController,
            bindings: {
                item: "="
            },
        });

    /** @ngInject */
    function ImportListItemController($scope, $translate, $uibModal, TargetAudienceService, $window, moment) {
        var $ctrl = this;


        const DATE_FORMAT = $translate.instant('momentDateTime24HFormat');

        $ctrl.statusDisplayMap = {
            PENDING: {
                class: 'pending',
                label: 'flyers.import.import-status.pending',
                tooltip: 'flyers.import.import-status.tooltips.pending'
            },
            IN_PROGRESS: {
                class: 'pending',
                label: 'flyers.import.import-status.in-progress',
                tooltip: 'flyers.import.import-status.tooltips.in-progress'
            },
            CANCELLED_REPEATED_IMPORT: {
                class: 'waiting_confirmation',
                label: 'flyers.import.import-status.cancelled-same-file',
                tooltip: 'flyers.import.import-status.tooltips.cancelled-same-file'
            },
            FINISHED: {
                class: 'paid',
                label: 'flyers.import.import-status.finished',
                tooltip: 'flyers.import.import-status.tooltips.finished'
            },
            FAILED: {
                class: 'cancelled',
                label: 'flyers.import.import-status.failed',
                tooltip: 'flyers.import.import-status.tooltips.failed'
            }
        };

        $ctrl.$onInit = function () {
            if($ctrl.item.createdOn) {
                $ctrl.formatedCreatedOn =  moment($ctrl.item.createdOn).format(DATE_FORMAT);
            }
            if($ctrl.item.startedOn) {
                $ctrl.formatedStartedOn =  moment($ctrl.item.startedOn).format(DATE_FORMAT);
            }
            if($ctrl.item.endedOn) {
                $ctrl.formatedEndedOn =  moment($ctrl.item.endedOn).format(DATE_FORMAT);
            }
            $ctrl.mobileTooltipMap = {};

            updateIsMobile();
            updateStatusTag();
        };

        $ctrl.toggleMobileTooltip = function (id, $event) {
            Object.keys($ctrl.mobileTooltipMap).forEach(function (key) {
                $ctrl.mobileTooltipMap[key] = false;
            });

            $ctrl.mobileTooltipMap[id] = true;
            $event.stopPropagation();
        };

        $ctrl.isTooltipOpen = function (id) {
            return $ctrl.mobileTooltipMap && $ctrl.mobileTooltipMap[id];
        };

        $ctrl.truncateText = function (text, size) {
            return truncateText(text, size);
        }

        function updateStatusTag() {
            var status = $ctrl.item.status;
            var statusConfig = $ctrl.statusDisplayMap[status];

            if (!statusConfig) {
                $ctrl.statusTag = null;
                return;
            }

            $ctrl.statusTag = {
                class: statusConfig.class,
                label: $translate.instant(statusConfig.label),
                tooltip: $translate.instant(statusConfig.tooltip)
            };
        }

        function updateIsMobile() {
            $ctrl.isMobile = $window.innerWidth <= 768;
        }

        $scope.$watch('$ctrl.item.status', function () {
            updateStatusTag();
        });

        angular.element($window).on('resize', function () {
            $scope.$apply(updateIsMobile);
        });
    }
})();
